import api from './api';

export const dashboardService = {
  getContactDashboardData: async (projectId, range = '7days') => {
    const response = await api.get(`/projects/${projectId}/dashboard?range=${range}`);
    return response.data;
  },
  api: api
};
